<input
  class="input__search"
  type="text"
  autofocus
  placeholder="{{ placeholder }}"
  [formControl]="searchFormControl"
  (keydown.space)="preventDefaultSpaceBehaviour($event)" />
